module.exports = __webpack_public_path__ + "static/media/Tailoring_thumb.7588cbe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trends/Tailoring_thumb.png
// module id = 349
// module chunks = 0